/* global Swiper,lightGallery */
const topSliderElements = document.querySelectorAll('[data-gallery-top-slider]');
const bottomSliderElements = document.querySelectorAll('[data-gallery-bottom-slider]');

// *******************************************************************************
// 1.0 - Tumbnail slider
// *******************************************************************************
const bottomSliderOptions = {
  threshold: 10,
  touchRatio: 0.33,
  preloadImages: false,
  lazy: {
    loadPrevNext: false,
  },
  slidesPerView: 3,
  spaceBetween: 12,
  watchSlidesProgress: true,
  breakpoints: {
    1023: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
};
bottomSliderElements.forEach((el) => {
  // eslint-disable-next-line no-unused-vars
  const bottomSlider = new Swiper(el, bottomSliderOptions);
});

// *******************************************************************************
// 2.0 - Main slider
// *******************************************************************************

const topSliderOptions = {
  threshold: 10,
  touchRatio: 0.33,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  preloadImages: false,
  lazy: {
    loadPrevNext: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  thumbs: {
    swiper: false,
  },
};

topSliderElements.forEach((el, i) => {
  const mainSliderParent = el.closest('.gallery');
  const arrowRight = mainSliderParent.querySelector('.swiper-button-next');
  const arrowLeft = mainSliderParent.querySelector('.swiper-button-prev');

  topSliderOptions.navigation.nextEl = arrowRight;
  topSliderOptions.navigation.prevEl = arrowLeft;
  topSliderOptions.thumbs.swiper = bottomSliderElements[i].swiper;

  // eslint-disable-next-line no-unused-vars
  const galleryTopSlider = new Swiper(el, topSliderOptions);
});

// *******************************************************************************
// 3.0 - Lightbox
// *******************************************************************************

const lightboxElement = document.querySelectorAll('[data-lightbox-parent');

lightboxElement.forEach((el) => {
  lightGallery(el, {
    selector: '.lightbox-item',
  });
});
